module.exports = require("./ff-Latn-LR.js");